<mat-form-field>
  <mat-label>Cliëntnummer</mat-label>
  <input matInput
         [(ngModel)]="nummer"
         (keyup.enter)="onNummerInput()"
         type="text"
         placeholder="2020/125414">
  <button mat-icon-button matIconSuffix (click)="onNummerInput()">
    <mat-icon>person_search</mat-icon>
  </button>
</mat-form-field>
